import createDOMPurify from "dompurify";
import PropTypes from "prop-types";

const domPurify = createDOMPurify();

const defaultOptions = {
  ALLOWED_TAGS: ["b", "i", "em", "strong", "a", "p", "span"],
  ALLOWED_ATTR: ["href"]
};

const sanitize = (dirty, options) =>
  domPurify.sanitize(dirty, { ...defaultOptions, ...options });

const SanitizeHTML = ({ html, options, className, inline = false }) => {
  const sanitizedHTML = sanitize(html, options);
  const ContainerElement = inline ? "span" : "div";
  return (
    <ContainerElement
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />
  );
};

SanitizeHTML.propTypes = {
  className: PropTypes.string,
  html: PropTypes.string,
  options: PropTypes.shape({}),
  inline: PropTypes.bool
};

export default SanitizeHTML;
